export const bancos = [
  {
    name: 'Banco Bankpar S.A.',
    codigo: '000'
  },
  {
    codigo: '001',
    name: 'Banco do Brasil S.A.'
  },
  {
    codigo: '003',
    name: 'Banco da Amazônia S.A.'
  },
  {
    codigo: '004',
    name: 'Banco do Nordeste do Brasil S.A.'
  },
  {
    codigo: '007',
    name: 'Banco Nacional de Desenvolvimento Econômico e Social – BNDES'
  },
  {
    codigo: '010',
    name: 'Credicoamo'
  },
  {
    codigo: '011',
    name: 'C.Suisse Hedging-Griffo Cv S.A (Credit Suisse)'
  },
  {
    codigo: '012',
    name: 'Banco Inbursa S.A.'
  },
  {
    codigo: '014',
    name: 'Natixis Brasil S.A. Banco Múltiplo'
  },
  {
    codigo: '016',
    name: 'Ccm Desp Trâns Sc E Rs'
  },
  {
    codigo: '017',
    name: 'BNY Mellon Banco S.A.'
  },
  {
    codigo: '018',
    name: 'Banco Tricury S.A.'
  },
  {
    name: 'Banco Azteca do Brasil S.A.',
    codigo: '019'
  },
  {
    codigo: '021',
    name: 'BANESTES S.A. Banco do Estado do Espírito Santo'
  },
  {
    codigo: '024',
    name: 'Banco BANDEPE S.A.'
  },
  {
    codigo: '025',
    name: 'Banco Alfa S.A.'
  },
  {
    codigo: '029',
    name: 'Banco Itaú Consignado S.A.'
  },
  {
    name: 'Banco Beg S.A.',
    codigo: '031'
  },
  {
    codigo: '033',
    name: 'Banco Santander (Brasil) S.A.'
  },
  {
    codigo: '036',
    name: 'Banco Bradesco BBI S.A.'
  },
  {
    codigo: '037',
    name: 'Banco do Estado do Pará S.A.'
  },
  { name: 'Banco do Estado do Piauí S.A. - BEP', codigo: '039' },
  {
    codigo: '040',
    name: 'Banco Cargill S.A.'
  },
  {
    codigo: '041',
    name: 'Banco do Estado do Rio Grande do Sul S.A.'
  },
  {
    name: 'Banco BVA S.A.',
    codigo: '044' },
  {
    codigo: '047',
    name: 'Banco do Estado de Sergipe S.A.'
  },
  {
    codigo: '051',
    name: 'Banco de Desenvolvimento do Espírito Santo S.A.'
  },
  {
    codigo: '060',
    name: 'Confidence Cc S.A'
  },
  {
    codigo: '062',
    name: 'Hipercard Banco Múltiplo S.A.'
  },
  {
    codigo: '063',
    name: 'Banco Bradescard S.A.'
  },
  {
    codigo: '064',
    name: 'Goldman Sachs do Brasil Banco Múltiplo S.A.'
  },
  {
    codigo: '065',
    name: 'Banco Andbank (Brasil) S.A.'
  },
  {
    codigo: '066',
    name: 'Banco Morgan Stanley S.A.'
  },
  {
    codigo: '069',
    name: 'Banco Crefisa S.A.'
  },
  {
    codigo: '070',
    name: 'BRB – Banco de Brasília S.A.'
  },
  { name: 'Banco Rural Mais S.A.', codigo: '072' },
  { name: 'BB Banco Popular do Brasil S.A.', codigo: '073' },
  {
    codigo: '074',
    name: 'Banco J. Safra S.A.'
  },
  {
    codigo: '075',
    name: 'Banco ABN AMRO S.A'
  },
  {
    codigo: '076',
    name: 'Banco KDB S.A.'
  },
  {
    codigo: '077',
    name: 'Banco Inter S.A.'
  },
  {
    codigo: '078',
    name: 'Haitong Banco de Investimento do Brasil S.A.'
  },
  {
    codigo: '079',
    name: 'Banco Original do Agronegócio S.A.'
  },
  {
    codigo: '080',
    name: 'B&T Cc Ltda'
  },
  {
    codigo: '081',
    name: 'BancoSeguro S.A.'
  },
  {
    codigo: '082',
    name: 'Banco Topázio S.A.'
  },
  {
    codigo: '083',
    name: 'Banco da China Brasil S.A.'
  },
  {
    codigo: '084',
    name: 'Uniprime Norte do Paraná – Coop de Economia e Crédito Mútuo dos Médicos'
  },
  {
    codigo: '085',
    name: 'Coop Central Ailos'
  },
  { name: 'OBOE Crédito Financiamento e Investimento S.A.', codigo: '086' },
  { name: 'Banco Randon S.A.', codigo: '088' },
  {
    codigo: '089',
    name: 'Ccr Reg Mogiana'
  },
  {
    codigo: '091',
    name: 'Unicred Central Rs'
  },
  {
    codigo: '092',
    name: 'Brickell S.A. Crédito'
  },
  {
    codigo: '093',
    name: 'Pólocred Scmepp Ltda'
  },
  {
    codigo: '094',
    name: 'Banco Finaxis S.A.'
  },
  {
    codigo: '095',
    name: 'Travelex Banco de Câmbio S.A.'
  },
  {
    codigo: '096',
    name: 'Banco B3 S.A.'
  },
  {
    codigo: '097',
    name: 'Cooperativa Central de Crédito Noroeste Brasileiro Ltda.'
  },
  {
    codigo: '098',
    name: 'Credialiança Ccr'
  },
  {
    codigo: '099',
    name: 'UNIPRIME Central – Central Interestadual de Cooperativas de Crédito Ltda.'
  },
  {
    codigo: '100',
    name: 'Planner Corretora De Valores S.A'
  },
  {
    codigo: '101',
    name: 'Renascenca Dtvm Ltda'
  },
  {
    codigo: '102',
    name: 'Xp Investimentos S.A'
  },
  {
    codigo: '104',
    name: 'Caixa Econômica Federal'
  },
  {
    codigo: '105',
    name: 'Lecca Crédito'
  },
  {
    codigo: '107',
    name: 'Banco BOCOM BBM S.A.'
  },
  {
    codigo: '108',
    name: 'Portocred S.A'
  },
  {
    codigo: '111',
    name: 'Banco Oliveira Trust Dtvm S.A'
  },
  {
    codigo: '113',
    name: 'Magliano S.A'
  },
  {
    codigo: '114',
    name: 'Central Cooperativa De Crédito No Estado Do Espírito Santo'
  },
  {
    codigo: '117',
    name: 'Advanced Cc Ltda'
  },
  {
    codigo: '118',
    name: 'Standard Chartered Bank (Brasil) S/A–Bco Invest.'
  },
  {
    codigo: '119',
    name: 'Banco Western Union do Brasil S.A.'
  },
  {
    codigo: '120',
    name: 'Banco Rodobens S.A.'
  },
  {
    codigo: '121',
    name: 'Banco Agibank S.A.'
  },
  {
    codigo: '121',
    name: 'Banco Agibank S.A.'
  },
  {
    codigo: '122',
    name: 'Banco Bradesco BERJ S.A.'
  },
  {
    codigo: '124',
    name: 'Banco Woori Bank do Brasil S.A.'
  },
  {
    codigo: '125',
    name: 'Plural S.A. – Banco Múltiplo'
  },
  {
    codigo: '126',
    name: 'BR Partners Banco de Investimento S.A.'
  },
  {
    codigo: '127',
    name: 'Codepe Cvc S.A'
  },
  {
    codigo: '128',
    name: 'MS Bank S.A. Banco de Câmbio'
  },
  {
    codigo: '129',
    name: 'UBS Brasil Banco de Investimento S.A.'
  },
  {
    codigo: '130',
    name: 'Caruana Scfi'
  },
  {
    codigo: '131',
    name: 'Tullett Prebon Brasil Cvc Ltda'
  },
  {
    codigo: '132',
    name: 'ICBC do Brasil Banco Múltiplo S.A.'
  },
  {
    codigo: '133',
    name: 'Cresol Confederação'
  },
  {
    codigo: '134',
    name: 'Bgc Liquidez Dtvm Ltda'
  },
  {
    codigo: '136',
    name: 'Unicred Cooperativa'
  },
  {
    codigo: '137',
    name: 'Multimoney Cc Ltda'
  },
  {
    codigo: '138',
    name: 'Get Money Cc Ltda'
  },
  {
    codigo: '139',
    name: 'Intesa Sanpaolo Brasil S.A. – Banco Múltiplo'
  },
  {
    codigo: '140',
    name: 'Easynvest – Título Cv S.A'
  },
  {
    codigo: '142',
    name: 'Broker Brasil Cc Ltda'
  },
  {
    codigo: '143',
    name: 'Treviso Corretora de Câmbio S.A.'
  },
  {
    codigo: '144',
    name: 'BEXS Banco de Câmbio S.A.'
  },
  {
    codigo: '145',
    name: 'Levycam Ccv Ltda'
  },
  {
    codigo: '146',
    name: 'Guitta Corretora de Câmbio Ltda'
  },
  {
    codigo: '149',
    name: 'Facta S.A. Cfi'
  },
  {
    codigo: '157',
    name: 'Icap Do Brasil Ctvm Ltda'
  },
  {
    codigo: '159',
    name: 'Casa Credito S.A'
  },
  {
    codigo: '163',
    name: 'Commerzbank Brasil S.A. – Banco Múltiplo'
  },
  { name: 'HSBC Finance (Brasil) S.A. - Banco Múltiplo', codigo: '168' },
  {
    codigo: '169',
    name: 'Banco Olé Bonsucesso Consignado S.A.'
  },
  {
    codigo: '172',
    name: 'Albatross Ccv S.A'
  },
  {
    codigo: '173',
    name: 'BRL Trust Distribuidora de Títulos e Valores Mobiliários S.A.'
  },
  {
    codigo: '174',
    name: 'Pernambucanas Financ S.A'
  },
  {
    codigo: '177',
    name: 'Guide Investimentos S.A. Corretora de Valores'
  },
  {
    codigo: '180',
    name: 'Cm Capital Markets Cctvm Ltda'
  },
  {
    codigo: '182',
    name: 'Dacasa Financeira S/A'
  },
  {
    codigo: '183',
    name: 'Socred S.A'
  },
  {
    codigo: '184',
    name: 'Banco Itaú BBA S.A.'
  },
  {
    codigo: '188',
    name: 'Ativa Investimentos S.A'
  },
  {
    codigo: '189',
    name: 'HS Financeira S/A Crédito'
  },
  {
    codigo: '190',
    name: 'Servicoop'
  },
  {
    codigo: '191',
    name: 'Nova Futura Corretora de Títulos e Valores Mobiliários Ltda.'
  },
  {
    codigo: '194',
    name: 'Parmetal Distribuidora de Títulos e Valores Mobiliários Ltda'
  },
  {
    codigo: '196',
    name: 'Banco Fair Corretora de Câmbio S.A'
  },
  {
    codigo: '197',
    name: 'Stone Pagamentos S.A'
  },
  {
    codigo: '204',
    name: 'Banco Bradesco Cartões S.A.'
  },
  {
    codigo: '208',
    name: 'Banco BTG Pactual S.A.'
  },
  {
    codigo: '212',
    name: 'Banco Original S.A.'
  },
  {
    codigo: '213',
    name: 'Banco Arbi S.A.'
  },
  { name: 'Banco Dibens S.A.', codigo: '214' },
  {
    name: 'Banco Comercial e de Investimento Sudameris S.A.',
    codigo: '215'
  },
  {
    codigo: '217',
    name: 'Banco John Deere S.A.'
  },
  {
    codigo: '218',
    name: 'Banco BS2 S.A.'
  },
  {
    codigo: '222',
    name: 'Banco Credit Agricole Brasil S.A.'
  },
  {
    codigo: '224',
    name: 'Banco Fibra S.A.'
  },
  {
    name: 'Banco Brascan S.A.',
    codigo: '225'
  },
  { name: 'Banco Cruzeiro do Sul S.A.', codigo: '229' },
  { name: 'Unicard Banco Múltiplo S.A.', codigo: '230' },
  {
    codigo: '233',
    name: 'Banco Cifra S.A.'
  },
  {
    codigo: '237',
    name: 'Banco Bradesco S.A.'
  },
  {
    codigo: '241',
    name: 'Banco Clássico S.A.'
  },
  {
    codigo: '243',
    name: 'Banco Máxima S.A.'
  },
  {
    codigo: '246',
    name: 'Banco ABC Brasil S.A.'
  },
  {
    codigo: '246',
    name: 'Banco ABC Brasil S.A.'
  },
  {
    name: 'Banco Boavista Interatlântico S.A.',
    codigo: '248'
  },
  {
    codigo: '249',
    name: 'Banco Investcred Unibanco S.A.'
  },
  {
    codigo: '250',
    name: 'BCV – Banco de Crédito e Varejo S.A.'
  },
  {
    codigo: '253',
    name: 'Bexs Corretora de Câmbio S/A'
  },
  {
    codigo: '254',
    name: 'Paraná Banco S.A.'
  },
  { name: 'Banco Real S.A.', codigo: '356' },
  {
    codigo: '260',
    name: 'Nu Pagamentos S.A (Nubank)'
  },
  {
    codigo: '265',
    name: 'Banco Fator S.A.'
  },
  {
    codigo: '266',
    name: 'Banco Cédula S.A.'
  },
  {
    codigo: '268',
    name: 'Barigui Companhia Hipotecária'
  },
  {
    codigo: '269',
    name: 'HSBC Brasil S.A. – Banco de Investimento'
  },
  {
    codigo: '270',
    name: 'Sagitur Corretora de Câmbio Ltda.'
  },
  {
    codigo: '271',
    name: 'IB Corretora de Câmbio'
  },
  {
    codigo: '273',
    name: 'Cooperativa de Crédito Rural de São Miguel do Oeste – Sulcredi/São Miguel'
  },
  {
    codigo: '276',
    name: 'Senff S.A. – Crédito'
  },
  {
    codigo: '278',
    name: 'Genial Investimentos Corretora de Valores Mobiliários S.A.'
  },
  {
    codigo: '279',
    name: 'Cooperativa de Crédito Rural de Primavera Do Leste'
  },
  {
    codigo: '280',
    name: 'Avista S.A. Crédito'
  },
  {
    codigo: '283',
    name: 'Rb Capital Investimentos Dtvm Ltda'
  },
  {
    codigo: '285',
    name: 'Frente Corretora de Câmbio Ltda.'
  },
  {
    codigo: '286',
    name: 'Cooperativa de Crédito Rural De Ouro'
  },
  {
    codigo: '288',
    name: 'Carol Distribuidora de Títulos e Valor Mobiliários'
  },
  {
    codigo: '290',
    name: 'Pagseguro Internet S.A'
  },
  {
    codigo: '292',
    name: 'BS2 Distribuidora de Títulos e Valores Mobiliários S.A.'
  },
  {
    codigo: '293',
    name: 'Lastro RDV Distribuidora de Títulos e Valores Mobiliários Ltda.'
  },
  {
    codigo: '298',
    name: 'Vips Cc Ltda'
  },
  {
    codigo: '299',
    name: 'Sorocred Crédito'
  },
  {
    codigo: '300',
    name: 'Banco de La Nacion Argentina'
  },
  {
    codigo: '301',
    name: 'Bpp Instituição De Pagamentos S.A'
  },
  {
    codigo: '310',
    name: 'Vortx Distribuidora de Títulos e Valores Mobiliários Ltda'
  },
  {
    codigo: '318',
    name: 'Banco BMG S.A.'
  },
  {
    codigo: '320',
    name: 'China Construction Bank (Brasil) Banco Múltiplo S.A.'
  },
  {
    codigo: '323',
    name: 'Mercado Pago – Conta Do Mercado Livre'
  },
  {
    codigo: '326',
    name: 'Parati – Crédito Financiamento e Investimento S.A.'
  },
  {
    codigo: '335',
    name: 'Banco Digio S.A'
  },
  {
    codigo: '336',
    name: 'Banco C6 S.A – C6 Bank'
  },
  {
    codigo: '340',
    name: 'Super Pagamentos e Administração de Meios Eletrônicos S.A.'
  },
  {
    codigo: '341',
    name: 'Itaú Unibanco S.A.'
  },
  {
    codigo: '348',
    name: 'Banco Xp S/A'
  },
  {
    codigo: '366',
    name: 'Banco Société Générale Brasil S.A.'
  },
  {
    codigo: '368',
    name: 'Banco Carrefour'
  },
  {
    codigo: '370',
    name: 'Banco Mizuho do Brasil S.A.'
  },
  {
    codigo: '376',
    name: 'Banco J. P. Morgan S.A.'
  },
  {
    codigo: '399',
    name: 'Kirton Bank S.A. – Banco Múltiplo'
  },
  {
    codigo: '487',
    name: 'Deutsche Bank S.A. – Banco Alemão'
  },
  {
    codigo: '488',
    name: 'JPMorgan Chase Bank, National Association'
  },
  {
    codigo: '389',
    name: 'Banco Mercantil do Brasil S.A.'
  },
  {
    codigo: '394',
    name: 'Banco Bradesco Financiamentos S.A.'
  },
  { name: 'UNIBANCO - União de Bancos Brasileiros S.A.', codigo: '409' },
  {
    codigo: '412',
    name: 'Banco Capital S.A.'
  },
  {
    codigo: '422',
    name: 'Banco Safra S.A.'
  },
  { name: 'Banco Rural S.A.', codigo: '453' },
  {
    codigo: '456',
    name: 'Banco MUFG Brasil S.A.'
  },
  {
    codigo: '464',
    name: 'Banco Sumitomo Mitsui Brasileiro S.A.'
  },
  {
    codigo: '473',
    name: 'Banco Caixa Geral – Brasil S.A.'
  },
  {
    codigo: '477',
    name: 'Citibank N.A.'
  },
  {
    codigo: '479',
    name: 'Banco ItauBank S.A'
  },
  {
    codigo: '492',
    name: 'ING Bank N.V.'
  },
  {
    codigo: '494',
    name: 'Banco de La Republica Oriental del Uruguay'
  },
  {
    codigo: '495',
    name: 'Banco de La Provincia de Buenos Aires'
  },
  {
    codigo: '505',
    name: 'Banco Credit Suisse (Brasil) S.A.'
  },
  {
    codigo: '545',
    name: 'Senso Ccvm S.A'
  },
  {
    codigo: '600',
    name: 'Banco Luso Brasileiro S.A.'
  },
  {
    codigo: '604',
    name: 'Banco Industrial do Brasil S.A.'
  },
  {
    codigo: '610',
    name: 'Banco VR S.A.'
  },
  {
    codigo: '611',
    name: 'Banco Paulista S.A.'
  },
  {
    codigo: '612',
    name: 'Banco Guanabara S.A.'
  },
  {
    codigo: '613',
    name: 'Omni Banco S.A.'
  },
  {
    codigo: '623',
    name: 'Banco PAN S.A.'
  },
  {
    codigo: '626',
    name: 'Banco Ficsa S.A.'
  },
  {
    codigo: '630',
    name: 'Banco Smartbank S.A.'
  },
  {
    codigo: '633',
    name: 'Banco Rendimento S.A.'
  },
  {
    codigo: '634',
    name: 'Banco Triângulo S.A.'
  },
  {
    codigo: '637',
    name: 'Banco Sofisa S.A.'
  },
  { name: 'Banco Prosper S.A.', codigo: '638' },
  {
    codigo: '641',
    name: 'Banco Alvorada S.A.'
  },
  {
    codigo: '643',
    name: 'Banco Pine S.A.'
  },
  {
    codigo: '652',
    name: 'Itaú Unibanco Holding S.A.'
  },
  {
    codigo: '653',
    name: 'Banco Indusval S.A.'
  },
  {
    codigo: '654',
    name: 'Banco A.J.Renner S.A.'
  },
  {
    codigo: '655',
    name: 'Banco Votorantim S.A.'
  },
  {
    codigo: '658',
    name: 'Banco Porto Real de Investimentos S.A.'
  },
  {
    codigo: '707',
    name: 'Banco Daycoval S.A.'
  },
  {
    codigo: '712',
    name: 'Banco Ourinvest S.A.'
  },
  { name: 'Banif-Banco Internacional do Funchal (Brasil)S.A.', codigo: '719' },
  {
    codigo: '720',
    name: 'Banco Maxinvest S.A.'
  },
  { name: 'Banco Credibel S.A.', codigo: '721' },
  { name: 'Banco Porto Seguro S.A.', codigo: '724' },
  { name: 'Banco Gerdau S.A.', codigo: '734' },
  { name: 'Banco Pottencial S.A.', codigo: '735' },
  { name: 'Banco Morada S.A.', codigo: '738' },
  {
    codigo: '739',
    name: 'Banco Cetelem S.A.'
  },
  {
    name: 'Banco Barclays S.A.',
    codigo: '740'
  },
  {
    codigo: '741',
    name: 'Banco Ribeirão Preto S.A.'
  },
  {
    codigo: '743',
    name: 'Banco Semear S.A.'
  },
  { name: 'BankBoston N.A.', codigo: '744' },
  {
    codigo: '745',
    name: 'Banco Citibank S.A.'
  },
  {
    codigo: '746',
    name: 'Banco Modal S.A.'
  },
  {
    codigo: '747',
    name: 'Banco Rabobank International Brasil S.A.'
  },
  {
    codigo: '748',
    name: 'Banco Cooperativo Sicredi S.A.'
  },
  {
    codigo: '748',
    name: 'Banco Cooperativo Sicredi S.A.'
  },
  { name: 'Banco Simples S.A.', codigo: '749' },
  {
    codigo: '751',
    name: 'Scotiabank Brasil S.A. Banco Múltiplo'
  },
  {
    codigo: '752',
    name: 'Banco BNP Paribas Brasil S.A.'
  },
  {
    codigo: '753',
    name: 'Novo Banco Continental S.A. – Banco Múltiplo'
  },
  {
    codigo: '754',
    name: 'Banco Sistema S.A.'
  },
  {
    codigo: '755',
    name: 'Bank of America Merrill Lynch Banco Múltiplo S.A.'
  },
  {
    codigo: '756',
    name: 'Banco Cooperativo do Brasil S.A. – BANCOOB'
  },
  {
    codigo: '757',
    name: 'Banco KEB HANA do Brasil S.A.'
  },
  { name: 'Conductor FlexAssists', codigo: '9991' },
  { name: 'Conductor Alpha Card', codigo: '9992' },
  {
    codigo: '091-4',
    name: 'Unicred Central do Rio Grande do Sul'
  },
  {
    codigo: '085-x',
    name: 'Cooperativa Central de Crédito Urbano-CECRED'
  },
  {
    codigo: '087-6',
    name: 'Cooperativa Central de Economia e Crédito Mútuo das Unicredsde Santa Catarina e Paraná'
  },
  {
    codigo: '089-2',
    name: 'Cooperativa de Crédito Rural da Região da Mogiana'
  },
  {
    codigo: '090-2',
    name: 'Cooperativa Central de Economia e Crédito Mutuo – SICOOB UNIMAIS'
  },
  {
    codigo: '098-1',
    name: 'CREDIALIANÇA COOPERATIVA DE CRÉDITO RURAL'
  },
  {
    codigo: '114-7',
    name: 'Central das Cooperativas de Economia e Crédito Mútuo doEstado do Espírito Santo Ltda.'
  },
  { name: 'Banco Fiat S.A.', codigo: 'M03' },
  { name: 'Banco de Lage Landen Brasil S.A.', codigo: 'M06' },
  { name: 'Banco GMAC S.A.', codigo: 'M07' },
  {
    name: 'Banco Citicard S.A.',
    codigo: 'M08'
  },
  { name: 'Banco Itaucred Financiamentos S.A.', codigo: 'M09' },
  { name: 'Banco Moneo S.A.', codigo: 'M10' },
  { name: 'Banco IBM S.A.', codigo: 'M11' },
  { name: 'Banco Maxinvest S.A.', codigo: 'M12' },
  { name: 'Banco Volkswagen S.A.', codigo: 'M14' },
  { name: 'Banco Rodobens S.A.', codigo: 'M16' },
  { name: 'Banco Ford S.A.', codigo: 'M18' },
  {
    name: 'Banco CNH Industrial Capital S.A.',
    codigo: 'M19'
  },
  { name: 'Banco Toyota do Brasil S.A.', codigo: 'M20' },
  { name: 'Banco Daimlerchrysler S.A.', codigo: 'M21' },
  { name: 'Banco Honda S.A.', codigo: 'M22' },
  { name: 'Banco Volvo (Brasil) S.A.', codigo: 'M23' },
  { name: 'Banco PSA Finance Brasil S.A.', codigo: 'M24' },
];



// WEBPACK FOOTER //
// ./src/app/shared/services/conta/bancos.service.ts